import type { DocumentStateExportFilters } from "~/types/ReportingDocumentStateExport";

export const useDocumentStateExportForm = () => {
  const mediaTypeIds = ref<number[]>([]);
  const createdByUserId = ref<number | null>(null);
  const merchantId = ref<number | null>(null);
  const marketIds = ref<number[]>([]);

  const reset = () => {
    mediaTypeIds.value = [];
    createdByUserId.value = null;
    merchantId.value = null;
    marketIds.value = [];
  };

  const toFilters = (): DocumentStateExportFilters => ({
    mediaTypeIds: mediaTypeIds.value,
    createdByUserId: createdByUserId.value,
    merchantId: merchantId.value,
    marketIds: marketIds.value,
  });

  return {
    mediaTypeIds,
    createdByUserId,
    merchantId,
    marketIds,
    reset,
    toFilters,
  };
};
